<template>
  <v-app>
    <div v-if="!bareLayout">
      <Nav v-if="checkToken()" />
      <v-main>
        <v-container fluid>
          <v-row class="fill-height">
            <v-col>
              <transition name="fade">
                <router-view></router-view>
              </transition>
            </v-col>
          </v-row>
        </v-container>
      </v-main>
      <Footer v-if="checkToken()" />
    </div>
    <div v-else>
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </v-app>
</template>

<script>
import Nav from "./components/molecules/Nav";
import Footer from "./components/molecules/Footer";
import axios from "axios";
export default {
  name: "App",
  components: {
    Nav,
    Footer,
  },
  data: () => ({
    sidebarMenu: true,
    toggleMini: false,
    WHPhoto: false,
  }),
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = (to.meta && to.meta.title) || to.name || "productsDB";
      },
    },
  },
  computed: {
    bareLayout() {
      const n = this.$route.name;
      return n === "WHPhotos" || n === "Landing" || n === "Login";
    },
  },
  methods: {
    checkToken() {
      if (localStorage.getItem("token")) {
        return true;
      } else {
        return false;
      }
    },
    checkDarkTheme() {
      if (localStorage.getItem("dark")) {
        this.$vuetify.theme.dark = true;
      }
    },
  },
  created() {
    var query = {
      token: this.$route.query["bc-auth-token"],
      userId: this.$route.query["user_id"],
      initials: this.$route.query["initials"],
      uniqueCode: this.$route.query["uniqueCode"],
      permissions: this.$route.query["permissions"],
    };
    console.log(query);
    if (
      query.token &&
      query.userId &&
      query.initials &&
      query.uniqueCode &&
      query.permissions
    ) {
      localStorage.setItem("token", query.token);
      localStorage.setItem("user-id", query.userId);
      localStorage.setItem("initials", query.initials);
      localStorage.setItem("uniqueCode", query.uniqueCode);
      localStorage.setItem("permissions", query.permissions);
      localStorage.setItem("entrySource", "brandclub.site");
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$route.query["bc-auth-token"];
        this.$router.push("/");
      location.reload();
    }
  },
  mounted() {
    this.checkDarkTheme();
    if (this.$route.name == "WHPhotos") this.WHPhoto = true;
  },
};
</script>
